var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"scroll-top"},[_c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"grid-x grid-padding-x"},[_c('div',{staticClass:"small-24 cell --flex justify-end"},[_c('button',{staticClass:"--button --rounded --scroll-top --chevron-up",on:{"click":_vm.scrollUp}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }